import { render } from "./Wall.vue?vue&type=template&id=5e173e73"
import script from "./Wall.vue?vue&type=script&lang=js"
export * from "./Wall.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__